export const eventsReducer = (
  state = {
    data: {
      rows: [],
    },
  },
  action
) => {
  switch (action.type) {
    case "REQUEST_EVENTS":
      return { ...state, loading: true };
    case "GET_EVENTS_SUCCESS":
      // create set of events for infinite scroll (immutable)
      function combineUniqueEvents(arr1, arr2) {
        const existing = arr1 ?? [];
        const next = [...existing];
        (arr2 ?? []).forEach((obj) => {
          if (
            !next.some(
              (item) => JSON.stringify(item) === JSON.stringify(obj)
            )
          ) {
            next.push(obj);
          }
        });
        return next;
      }

      return {
        loading: false,
        data: {
          ...state.data,
          rows: combineUniqueEvents(state.data?.rows, action.payload.rows),
          count: action.payload.count,
        },
      };

    case "GET_EVENTS__SEARCH_SUCCESS":
      return {
        loading: false,
        data: {
          ...state.data,
          rows: action.payload.rows,
          count: action.payload.count,
        },
      };

    case "FAIL_EVENTS":
      return { loading: false, data: { rows: [] }, error: action.payload };
    case "RESET_EVENTS":
      return {
        loading: false,
        data: {
          rows: [],
        },
      };
    default:
      return state;
  }
};

export const eventByIdReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case "REQUEST_EVENT":
      return { ...state, loading: true };
    case "GET_EVENT_SUCCESS":
      return { loading: false, data: action.payload, OccurrenceCreated: false };

    case "FAIL_EVENT":
      return { loading: false, data: {}, error: action.payload };

    case "CREATE_SINGLE_OCCURRENCE_REQUEST":
      return { ...state, loading: true };
    case "CREATE_SINGLE_OCCURRENCE_SUCCESS":
      return {
        loading: false,
        OccurrenceCreated: true,
        data: {
          ...state.data,
          Occurrences: [...(state.data?.Occurrences ?? []), action.payload],
        },
      };
    case "CREATE_SINGLE_OCCURRENCE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "EDIT_EVENT_OCCURRENCE_REQUEST":
      return { ...state, loading: true };
    case "EDIT_EVENT_OCCURRENCE_SUCCESS":
      return {
        loading: false,
        data: {
          ...state.data,
          Occurrences: (state.data?.Occurrences ?? []).map((occ) =>
            occ.uuid === action.payload.uuid ? action.payload : occ
          ),
        },
      };
    case "EDIT_EVENT_OCCURRENCE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "RESET_EVENT":
      return {
        loading: false,
        data: {},
        OccurrenceCreated: false,
      };
    default:
      return state;
  }
};

export const addEventReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "ADD_EVENT_REQUEST":
      return { ...state, loading: true };
    case "ADD_EVENT_SUCCESS":
      return { loading: false, ...action.payload };
    case "ADD_EVENT_FAIL":
      return { loading: false, error: action.payload };
    case "ADD_RESET_EVENT":
      return { loading: false };
    default:
      return state;
  }
};

export const editEventReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "EDIT_EVENT_REQUEST":
      return { ...state, loading: true };
    case "EDIT_EVENT_SUCCESS":
      return { loading: false, success: true, ...action.payload };
    case "EDIT_EVENT_FAIL":
      return { loading: false, error: action.payload };
    case "EDIT_RESET_EVENT":
      return { loading: false };
    default:
      return state;
  }
};

export const deleteEventReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "DELETE_EVENT_REQUEST":
      return { ...state, loading: true };
    case "DELETE_EVENT_SUCCESS":
      return { loading: false, success: true, ...action.payload };
    case "DELETE_EVENT_FAIL":
      return { loading: false, error: action.payload };
    case "DELETE_RESET_EVENT":
      return { loading: false };
    default:
      return state;
  }
};

export const getEventAdminReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "GET_ADMIN_EVENT_REQUEST":
      return { ...state, loading: true };
    case "GET_ADMIN_EVENT_SUCCESS":
      return { loading: false, success: true, data: action.payload };
    case "GET_ADMIN_EVENT_FAIL":
      return { loading: false, error: action.payload };
    case "GET_ADMIN_EVENT_EVENT":
      return { loading: false };
    default:
      return state;
  }
};
